import React from 'react';
import type { ReadinessGrade } from '../types';

interface ReadinessBadgeProps {
  score: number;
  grade: ReadinessGrade;
  wordCount: number;
  onClick?: () => void;
}

const GRADE_STYLES: Record<ReadinessGrade, { bg: string; text: string; ring: string; label: string }> = {
  strong: { bg: 'bg-emerald-500/20', text: 'text-emerald-400', ring: 'ring-emerald-500/40', label: 'STRONG' },
  moderate: { bg: 'bg-amber-500/20', text: 'text-amber-400', ring: 'ring-amber-500/40', label: 'MODERATE' },
  weak: { bg: 'bg-red-500/20', text: 'text-red-400', ring: 'ring-red-500/40', label: 'WEAK' },
};

export function ReadinessBadge({ score, grade, wordCount, onClick }: ReadinessBadgeProps): React.ReactElement {
  const s = GRADE_STYLES[grade];

  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-2.5 px-3.5 py-1.5 rounded-full ${s.bg} ring-1 ${s.ring} transition-all hover:brightness-125 cursor-pointer`}
    >
      <span className={`text-lg font-black tabular-nums ${s.text}`}>{score}</span>
      <span className="w-px h-4 bg-slate-600" />
      <span className={`text-[10px] font-bold uppercase tracking-widest ${s.text}`}>{s.label}</span>
      <span className="text-[10px] text-slate-500 font-mono">{wordCount}w</span>
    </button>
  );
}
